import React from 'react';
import { useField } from 'formik';
import { IFormikFieldProps } from './types';
import { DatePickerModel } from '@syncfusion/ej2-calendars';
import { DefaultHtmlAttributes } from '@syncfusion/ej2-react-base';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';

export type DatePickerProps = IFormikFieldProps &
    DatePickerModel &
    DefaultHtmlAttributes;

export const DatePicker: React.FC<any> = props => {
    const [field, , helpers] = useField(props);

    return (
        <DatePickerComponent
            immediateRender
            format="dd/MM/yyyy"
            value={field.value ? new Date(field.value) : null} // Convert to Date object if value exists
            {...props}
            change={e => {
                if (!e || !e.value) {
                    helpers.setValue(null);
                    return;
                }

                // Extract the date and format it as YYYY-MM-DD to avoid timezone issues
                const selectedDate = new Date(e.value);
                const formattedDate = `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1)
                    .toString()
                    .padStart(2, '0')}-${selectedDate
                        .getDate()
                        .toString()
                        .padStart(2, '0')}`;

                // Set the formatted date string in Formik state
                helpers.setValue(formattedDate);
            }}
        />
    );
};
